import React, {useCallback, useEffect, useRef, useState} from "react";
import axiosApi from '../../../../api/daonAxios';
import URL, {DPAUTH_APIKEY, DPAUTH_URL} from "../../../../constants/url";
import {formatDate, getDpNiceResponse, getDpSnsSignin, setDpAuthResetPhonenumberCid} from "../../../../assets/js/comm";
import ToastPopup from "../../../../components/comm/ToastPopup";
import {useNavigate} from "react-router-dom";
import CODE from "../../../../constants/code";
import MSG from "../../../../constants/message";

const initialResult = {
    name: "",
    mobileNo: "",
    birthdate: "",
    gender: "",
    provider: "",
    encryptedCi: "",
};

function formatBirthdate(birthdate) {
    if (birthdate && birthdate.length === 8) {
        return `${birthdate.substring(0, 4)}-${birthdate.substring(4, 6)}-${birthdate.substring(6, 8)}`;
    }
    return birthdate || "";
}

function formatGender(gender) {
    if (gender === "1") return "남성";
    if (gender === "0") return "여성";
    return gender || "";
}

export default function NiceDpRedirectPage() {

    const navigate = useNavigate();

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [sec, setSec] = useState(3);
    const [redirecting, setRedirecting] = useState(false);
    const [baseMsg, setBaseMsg] = useState('');

    const [loading, setLoading] = useState(true);
    const [result, setResult] = useState(initialResult);
    const [error, setError] = useState("");

    const intervalRef = useRef(null);
    const timeoutRef = useRef(null);

    const isFirstRender = useRef(true);

    const clearTimers = () => {
        if (intervalRef.current) clearInterval(intervalRef.current);
        if (timeoutRef.current) clearTimeout(timeoutRef.current);
        intervalRef.current = null;
        timeoutRef.current = null;
    };

    const startRedirect = (message, seconds = 3, url = URL.LANDING) => {
        clearTimers();
        setBaseMsg(message);
        setSec(seconds);
        setToast(true);
        setRedirecting(true);

        intervalRef.current = setInterval(() => {
            setSec((s) => (s > 0 ? s - 1 : 0));
        }, 1000);

        timeoutRef.current = setTimeout(() => {
            navigate(url, { replace: true });
        }, seconds * 1000);
    };

    useEffect(() => {
        if (redirecting) {
            setToastMessage(`${baseMsg} ${sec}초 후 \n로그인 화면으로 이동합니다.`);
        }
    }, [redirecting, baseMsg, sec]);

    useEffect(() => {
        return () => clearTimers();
    }, []);


    useEffect(() => {
        const fetchResult = async () => {
            const urlParams = new URLSearchParams(window.location.search);
            const authTicket = sessionStorage.getItem("auth_ticket");
            const webTransactionId = urlParams.get("web_transaction_id");

            // 데이터확인..테스트성..
            //( " ================> urlParams : ", urlParams);
            //console.log( " ================> webTransactionId : ", webTransactionId);
            //console.log( " ================> authTicket : ", authTicket);

            if (!webTransactionId || !authTicket) {
                startRedirect("인증 정보가 만료되었거나 누락되었습니다.");
                //setError("인증 정보가 만료되었거나 누락되었습니다.");
                //setLoading(false);
                return;
            }

            try {

                const niceResult = await getDpNiceResponse(authTicket, webTransactionId);
                //console.log( "================> auth/nice/result niceResult : ", niceResult);

                const provider = niceResult?.provider?.toLowerCase() || "";
                const encryptedCi = niceResult.encryptedCi || "";
                const moveToMenu = niceResult.param1 || ""; // target path 용도로 사용
                // const param2 = niceResult.param2 || ""; // 임의값 .. // 아직활용 안함.
                const usrSeCd = provider === 'naver' ? "12" : provider === 'kakao' ? "13" :
                    provider === 'google' ? "14" : provider === 'apple' ? "15" : "11";

                if (!provider) {
                    startRedirect("올바른 접근이 아닙니다.");
                    return;
                }

                let viewResultJson = {  // 저장용으로도 같이 쓸수있도록 조정..
                    usrNm: niceResult.name || "",
                    mblNo: niceResult.mobileNo || "",
                    brthdy: niceResult.birthdate || "",
                    brthdyFormat: formatBirthdate(niceResult.birthdate),
                    gendr: niceResult.gender,
                    gendrFormat: formatGender(niceResult.gender),
                    provider: provider,
                    encptCidVal: niceResult.encryptedCi || "",
                    param1: niceResult.param1 || "",
                    param2: niceResult.param2 || "",
                    usrSeCd: usrSeCd,
                };

                // 보수성 처리 .. component.. 확인가능
                setResult( { ...viewResultJson });

                sessionStorage.removeItem("auth_ticket"); // 사용직후 삭제 처리..

                const snsToken = sessionStorage.getItem("sns_token");
                const emailAdres = sessionStorage.getItem("sns_email");
                //const moveToMenu = sessionStorage.getItem("moveToMenu");

                //if (provider === 'password' || provider === 'phone_otp' || provider === 'kakao' || provider === 'naver' || provider === 'google' || provider === 'apple') {

                    if (!encryptedCi) {
                        startRedirect('인증 결과에 CI 값이 없습니다.');
                        return;
                    }

                    if (provider === 'phone_otp') {

                        const response = await setDpAuthResetPhonenumberCid({
                            cid: encryptedCi,
                            phonenumber: niceResult?.mobileNo
                        });

                        if (response) {
                            chagneMblNo(niceResult?.mobileNo);
                        } else {
                            startRedirect('휴대전화번호 변경에 실패 했습니다.', 3, URL.MYINFO_WRITE);
                        }
                        return;
                    }

                    // 실제 서비스에 환자정보가 존재하는지 검증..
                    const resPatnt = await retrievePatntInfoByCi(encryptedCi, viewResultJson);

                    //console.log( " ===================> retrievePatntInfoByCi response :: ", resPatnt );

                    if (!resPatnt?.data || resPatnt.data.resultCode !== CODE.RCV_SUCCESS) {
                        startRedirect((resPatnt?.data?.resultMessage || '인증 결과 처리 실패') + '(인증 결과 처리 실패)');
                        return;
                    }

                    const {isSignUp, iitpUser, patntInfo} = resPatnt.data.result || {}; // patntInfo 구조 : patntInfo.resultCnt : int / patntInfo.resultList : []

                    if (provider === 'password' && !snsToken) {
                        if (isSignUp === 'Y' && iitpUser?.usrId) {
                            // 아이디 찾기 경로
                            if (moveToMenu === "findId") {
                                navigate(URL.FIND_ID, {
                                    state: {
                                        ...viewResultJson,
                                        provider,
                                        emailAdres,
                                        usrId: iitpUser.usrId,
                                        signupDt: formatDate(iitpUser?.signupDt?.replace(/[ .:-]/g, '').substring(0, 8), 2)
                                    }
                                });
                            } else if (moveToMenu === "findPw") {
                                navigate(URL.FIND_PASSWORD, {
                                    state: {
                                        ...viewResultJson,
                                        provider,
                                        emailAdres,
                                        usrId: iitpUser.usrId,
                                        usrUid: iitpUser.usrUid
                                    }
                                });
                            } else {
                                // 환자가 등록되었는지 감지..
                                if( patntInfo?.resultCnt > 0 ) { // 등록이 되어있으면

                                    startRedirect('이미 가입되어 있는 사용자입니다.');
                                    //
                                } else {
                                    // 이미 가입된 사용자가 이 구간에 들어오면 계정이 가공되었든지, 정상적 상태가 아닐 수 있다..
                                    // 환자 등록 안내문구 필요.. 관리자에 요청
                                    navigate(URL.MEMBERSHIP_FAILED);

                                }

                            }
                        } else {
                            if (moveToMenu === "findId") {// 아이디 찾기에서 진행한 것인지 확인!..
                                startRedirect('가입된 정보가 없습니다. 로그인 화면으로 이동합니다.');
                            } else {
                                if (patntInfo?.resultCnt > 0) {
                                    navigate(URL.AGREE_CONDITIONS,
                                        {
                                            state: {
                                                ...viewResultJson
                                                , provider
                                                , emailAdres
                                                , cnncPatntList: patntInfo.resultList
                                            }
                                        });
                                } else {
                                    // IITP 는 환자 등록이 필수 요소로서 사전 등록이 되어 있지 않으면 가입을 하지 못한다..
                                    // 환자 등록 안내문구 필요.. 관리자에 요청
                                    navigate(URL.MEMBERSHIP_FAILED);
                                }
                            }
                        }
                        return;
                    }

                    // SNS 간편가입 전용 ..  테스트 및 검토가 필요함.
                    if (snsToken) {

                        if (!snsToken) {
                            startRedirect('올바른 접근이 아닙니다.');
                            return;
                        }

                        const resSnsToken = await getSnsToken(snsToken);
                        if (!resSnsToken?.data || resSnsToken.data.resultCode !== CODE.RCV_SUCCESS) {
                            startRedirect((resSnsToken?.data?.resultMessage || 'sns 토큰 호출 실패') + '(sns 토큰 호출 실패)');
                            return;
                        }

                        const {accessToken, sns} = resSnsToken.data.result;

                        if (isSignUp === 'Y') {

                            if( patntInfo?.resultCnt > 0 ) {

                                const snsSignObj = {
                                    sns,
                                    [(['naver', 'kakao'].includes(sns) ? 'accessToken' : 'idToken')]: accessToken,
                                    displayName: niceResult.name,
                                    phoneNumber: niceResult.mobileNo,
                                    email: emailAdres,
                                    birth: niceResult.birthdate,
                                    gender: niceResult.gender,
                                    staff: false,
                                    cid: encryptedCi
                                };

                                const resSnsSign = await getDpSnsSignin(snsSignObj);

                                if (resSnsSign?.accessToken) {
                                    const jToken = resSnsSign.accessToken;

                                    sessionStorage.setItem('loginUser', JSON.stringify(iitpUser));
                                    localStorage.setItem('jToken', jToken);

                                    actionSignup(resSnsSign.accessToken, resSnsSign.refreshToken, sns);
                                } else {
                                    alert(MSG.ERR_PSSUSR + "\n사용자의 " + MSG.ERR_AUTH);
                                }

                            } else {
                                // 이미 가입된 사용자가 이 구간에 들어오면 계정이 가공되었든지, 정상적 상태가 아닐 수 있다..
                                // 환자 등록 안내문구 필요.. 관리자에 요청
                                navigate(URL.MEMBERSHIP_FAILED);
                            }
                        } else {
                            // 신규~
                            if( patntInfo?.resultCnt > 0 ) { // 환자번호가 있는 경우에만 다음스텝 진행 가능.
                                navigate(URL.AGREE_CONDITIONS, {
                                    state: {
                                        ...viewResultJson,
                                        provider: sns,
                                        accessToken,
                                        emailAdres,
                                        cnncPatntList : patntInfo.resultList,
                                    }
                                });
                            } else {
                                // IITP 는 환자 등록이 필수 요소로서 사전 등록이 되어 있지 않으면 가입을 하지 못한다..
                                //
                                navigate(URL.MEMBERSHIP_FAILED);
                            }
                        }
                    }
                //}

            } catch (err) {
                if (err.response) {
                    startRedirect(`인증 조회 실패 : HTTP ${err.response.status}`);
                    //setError(`조회 실패 : HTTP ${err.response.status}`);
                } else if (err.request) {
                    startRedirect("인증 조회 실패 : 서버 응답이 없습니다.");
                } else {
                    startRedirect(`인증 조회 실패 : ${err.message}`);
                }
            } finally {
                setLoading(false);
            }

        };

        fetchResult();
    }, []);


    const retrievePatntInfoByCi = (encryptedCi, user) => {
        const url = `/signup/retrievePatntInfoByCi`;
        const requestParams = {
            encptCidVal: encryptedCi
            , usrNm: user?.usrNm
            , gendr: user?.gendr
            , brthdy: user?.brthdy
            , mblNo: user?.mblNo
        };

        return axiosApi.post(url, requestParams, {});
    };

    const getSnsToken = (r1) => {
        const url = `/nice/auth/sns/token/${r1}`;
        return axiosApi.get(url);
    };

    const actionSignup = async (accessToken, refreshToken, provider) => {
        const usrSeCd = provider === 'naver' ? "12" : provider === 'kakao' ? "13" :
            provider === 'google' ? "14" : provider === 'apple' ? "15" : "";
        // 간편가입에 해당하는 경우, 환자 정보가 등록되어

        if (accessToken !== undefined && accessToken !== "") {
            const jToken = accessToken;
            const requestSignupUrl = "/signup/saveUser";

            const requestOptions = {
                headers: {
                    Authorization: `Bearer ${jToken}`,
                }
            };

            const signupReq = {
                crtfcTknVal: refreshToken,
                usrSeCd
            };

            await axiosApi.post(requestSignupUrl, signupReq, requestOptions)
                .then((res) => {
                    if (Number(res.data.resultCode) === Number(CODE.RCV_SUCCESS)) {
                        const iitpUser = res.data.result.iitpUser;

                        sessionStorage.setItem('loginUser', JSON.stringify(iitpUser));
                        localStorage.setItem('jToken', jToken);

                        if (iitpUser.usrHsptlMap.length > 0) {
                            navigate(URL.HOME_MAIN);
                        } else {
                            // 예외 상황.. 가입은 되어있지만...
                            //( " =================> actionSignup ... validation self-error :: checking!! ")
                        }
                    } else {
                        startRedirect(MSG.ERR_PSSUSR + "\n사용자의 " + MSG.ERR_AUTH);
                    }
                })
                .catch((err) => {
                    console.log(" ================> RCV_ERROR_SERVER ", err);
                });
        } else {
            alert(MSG.ERR_PSSUSR + "\n사용자의 " + MSG.ERR_AUTH);
        }
    };

    const chagneMblNo = useCallback(async (mblNo) => {
        const url = `/setting/phone/change`;
        const jToken = localStorage.getItem('jToken');

        const reqOptions = {
            headers: {
                Authorization: `Bearer ${jToken}`,
            }
        };

        await axiosApi.put(url, { mblNo }, reqOptions)
            .then((res) => {
                if (res.data.resultCode === CODE.RCV_SUCCESS) {
                    const iitpUser = res.data.result.iitpUser;
                    sessionStorage.setItem("loginUser", JSON.stringify(iitpUser));
                    navigate(URL.MYINFO_WRITE, { state: { cameFromNice: true, successYn: 'Y', successMsg: "휴대전화번호 변경이 완료되었습니다." } });
                } else {
                    startRedirect('휴대전화번호 변경에 실패 했습니다.', 3, URL.MYINFO_WRITE);
                }
            })
            .catch(err => {
                console.error("휴대폰 번호 저장 실패  : ", err);
            });
    }, []);

    return (

        <>
            {toast && (
                <ToastPopup
                    setToast={setToast}
                    position={"center"}
                    message={toastMessage}
                />
            )}
        {/*
        <div>
            <h2>본인인증 결과</h2>

            {loading && <p>인증 정보를 안전하게 복호화 중입니다...</p>}

            {!loading && error && <p>{error}</p>}

            {!loading && !error && (
                <>
                    <p>이름: {result.name}</p>
                    <p>휴대폰 번호: {result.mobileNo}</p>
                    <p>생년월일: {result.birthdate}</p>
                    <p>성별: {result.gender}</p>
                    <p>Provider: {result.provider}</p>
                    <p>암호화된 CI: {result.encryptedCi}</p>
                </>
            )}
        </div>
        */}
        </>
    );
}
